import { CreateListingChoosePickupAddress } from '../../../components/create-listing-choose-pickup-address/CreateListingChoosePickupAddress';

export const CreateListingChoosePickupAddressView = () => <CreateListingChoosePickupAddress />;
